import { render, staticRenderFns } from "./football-statistics.vue?vue&type=template&id=515b3068&scoped=true&"
import script from "./football-statistics.vue?vue&type=script&lang=js&"
export * from "./football-statistics.vue?vue&type=script&lang=js&"
import style0 from "./football-statistics.vue?vue&type=style&index=0&id=515b3068&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515b3068",
  null
  
)

export default component.exports